import { inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
//NOTE - Canonical ไม่ใช่ <meta> tag แต่เป็น <link rel="canonical"> จึงต้องใช้ DOCUMENT injection เพื่อ manipulate DOM โดยตรง
import { DOCUMENT } from '@angular/common';

export interface IMeta {
  name: string;
  title: string;
  description: string;
  keywords?: string;
  robots?: string;
  canonical?: string;
  publisher?: string;
}

export interface IOgTags extends Omit<IMeta, 'name'> {
  image: string;
}

@Injectable({ providedIn: 'root' })
export class MetaService {
  private readonly meta = inject(Meta);
  private readonly title = inject(Title);
  private readonly document = inject(DOCUMENT);

  updateMeta(meta: IMeta) {
    this.updateTitle(meta.name, meta.title);
    this.updateDescription(meta.name, meta.description);
    // ทำไมต้องใส่ if (meta.canonical) { this.updateCanonicalUrl(meta.canonical);}
    if (meta.canonical) {
      this.updateCanonicalUrl(meta.canonical);
    }
    // ทำไมต้องมี { name: 'keywords', content: meta.keywords } ใส่แค่ { name: 'keywords', content: meta.keywords } ไม่ได้หรอ ?
    // เพราะว่า meta.updateTag() ต้องการ object ที่มี property name และ content เพื่อที่จะอัพเดท tag ที่ถูกต้องใน head ของ HTML document

    if (meta.keywords) {
      this.meta.updateTag({ name: 'keywords', content: meta.keywords });
    }
    if (meta.robots) {
      this.meta.updateTag({ name: 'robots', content: meta.robots });
    }
    if (meta.publisher) {
      this.meta.updateTag({ name: 'publisher', content: meta.publisher });
    }
  }

  updateTitle(name: string, title: string) {
    // const concatTitle = `${name} - ` + title;
    const concatTitle = title;
    this.title.setTitle(concatTitle);
  }

  updateDescription(name: string, desc: string) {
    this.meta.updateTag({
      name: 'description',
      // content: `${name} - ` + desc,
      content: desc,
    });
  }

  updateCanonicalUrl(url: string) {
    const link: HTMLLinkElement =
      this.document.querySelector("link[rel='canonical']") || this.document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', url);
    this.document.head.appendChild(link);
  }

  updatePublisher(publisher: string) {
    this.meta.updateTag({ name: 'publisher', content: publisher });
  }

  // ==================  Set Open Graph tags  ==================
  updateOpenGraph(openGraph: IOgTags) {
    this.updateTwitterCard();
    this.updateOpenGraphImage(openGraph.image);
    this.updateOpenGraphTitle(openGraph.title);
    this.updateOpenGraphDescription(openGraph.description);
  }

  updateTwitterCard() {
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
  }

  updateOpenGraphImage(content: string) {
    this.meta.updateTag({ property: 'og:image', content: content });
    this.meta.updateTag({ name: 'twitter:image', content: content });
  }

  updateOpenGraphTitle(content: string) {
    this.meta.updateTag({ property: 'og:title', content: content });
    this.meta.updateTag({ name: 'twitter:title', content: content });
  }

  updateOpenGraphDescription(content: string) {
    this.meta.updateTag({ property: 'og:description', content: content });
    this.meta.updateTag({ name: 'twitter:description', content: content });
  }
}
